// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__EF7Mi"};